var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-header-container"},[_c('span',{staticClass:"comp-title"},[_vm._v(_vm._s(_vm.infos.title))]),_c('span',{staticClass:"comp-sub-title"},[_vm._v(_vm._s(_vm.infos.subTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }